import { useSnackbar } from 'notistack'
import { useCallback, useMemo } from 'react'

const errorOptions = {
  variant: 'error',
  //   persist: true,
  persist: false,
  autoHideDuration: 10000,
  //   preventDuplicate: true,
}

const warnOptions = {
  variant: 'warning',
  persist: false,
  autoHideDuration: 3000,
}

const infoOptions = {
  variant: 'info',
  persist: false,
  autoHideDuration: 2000,
}

const successOptions = {
  variant: 'success',
  persist: false,
  autoHideDuration: 2000,
}

export const useBar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const error = useCallback(
    (message, options = {}) => {
      return enqueueSnackbar(message, {
        SnackbarProps: {
          onClick: () => closeSnackbar(),
        },
        ...errorOptions,
        ...options,
      })
    },
    [enqueueSnackbar, closeSnackbar],
  )

  const warn = useCallback(
    (message, options = {}) => {
      return enqueueSnackbar(message, { ...warnOptions, ...options })
    },
    [enqueueSnackbar],
  )

  const info = useCallback(
    (message, options = {}) => {
      return enqueueSnackbar(message, { ...infoOptions, ...options })
    },
    [enqueueSnackbar],
  )

  const success = useCallback(
    (message, options = {}) => {
      return enqueueSnackbar(message, { ...successOptions, ...options })
    },
    [enqueueSnackbar],
  )

  return useMemo(
    () => ({
      error,
      warn,
      info,
      success,
      close: closeSnackbar,
    }),
    [error, warn, info, success, closeSnackbar],
  )
}

export default useBar
